import { ColorBoxLabel } from "../../../components/ColorBox";
import { FoldKV, ITooltip, SubKV } from "../util";
import { noiseRows } from "./noiseFormat";

/**
 * Geluid op het perceel zelf, per bron, uit de RIVM-geluidskaarten van
 * 10 x 10 m: de ongunstigste plek bepaalt de klasse, het bereik laat het
 * verschil tussen voorgevel en achtertuin zien. De buurthinder (Nuisance)
 * daaronder is een enquête-uitkomst per buurt; dit is een modelwaarde per
 * perceel.
 */
export const ParcelNoise = ({ rast }: { rast: Record<string, unknown> | undefined }) => {
  const rows = noiseRows(rast);
  if (!rows.length) return null;
  // Kopregel: alle bronnen samen als die er is, anders de luidste bron
  const head =
    rows.find((r) => r.key === "GeluidLdenTotaal") ??
    rows.reduce((a, b) => (b.stats.max > a.stats.max ? b : a));
  return (
    <FoldKV
      k="Geluid op perceel"
      summary={
        <ColorBoxLabel elem={head.elem}>
          <span className="text-gray-600">{head.relevant ? head.text : ""}</span>
          <ITooltip content="Lden, per 10 × 10 m (RIVM, Atlas Leefomgeving). Een ruwe indicatie: niet geschikt om de geluidbelasting op de gevel te toetsen."></ITooltip>
        </ColorBoxLabel>
      }
    >
      {rows.map((row) => (
        <SubKV key={row.key} k={row.label}>
          {row.relevant ? (
            <ColorBoxLabel elem={row.elem}>
              <span className="text-gray-600">
                {row.text}
                {row.aboveWho && (
                  <ITooltip content={`boven WHO-advies (${row.who} dB ${row.metric})`}>
                    {row.aboveWho}
                  </ITooltip>
                )}
              </span>
            </ColorBoxLabel>
          ) : (
            <span className="text-gray-600">{row.text}</span>
          )}
        </SubKV>
      ))}
    </FoldKV>
  );
};
